 <script>
	import { Router, Link, Route } from 'svelte-routing';
	import Home from './Home.svelte';
	import Login from './Login.svelte';
	import SignUp from './SignUp.svelte';
	import Dashboard from './Dashboard.svelte';
	import Pricing from './Pricing.svelte'; // Import the new Pricing component
  
	let token = localStorage.getItem('token');
  </script>
  
  <Router>
	<main class="vh-100 flex flex-column">
	  <nav class="flex justify-between items-center pa3 ph4 nav">
		<Link to="/" class="f1 fw6 link white no-underline custom-link" style="color: #e8d3b7;">NoonDev</Link>
		<div class="flex items-center">
		  <div class="relative mh3">
			<button class="link white no-underline bg-transparent bn f3 custom-link" style="color: #e8d3b7 !important;">
			  Features
			</button>
			<div class="absolute bg-white shadow-1 mt2 br2 dn features-menu">
			  <Link to="/" class="db pa2 black no-underline custom-link">Bakery Recipe</Link>
			  <Link to="/" class="db pa2 black no-underline custom-link">Cash App</Link>
			</div>
		  </div>
		  <Link to="/pricing" class="link white no-underline mh3 f3 custom-link" style="color: #e8d3b7;">Pricing</Link>
		  <div class="relative mh3">
			<button class="link white no-underline bg-transparent bn f3 custom-link" style="color: #e8d3b7 !important;">
			  Learn
			</button>
			<div class="absolute bg-white shadow-1 mt2 br2 dn learn-menu">
			  <Link to="/" class="db pa2 black no-underline custom-link">Wiki</Link>
			  <Link to="/" class="db pa2 black no-underline custom-link">Help</Link>
			</div>
		  </div>
		</div>
		<div class="flex">
		  <Link to="/login" class="link white no-underline mh3 f3 br3 ph3 pv2 custom-link" style="background-color: #e8d3b7; color: black;">Login</Link>
		  <Link to="/signup" class="link white no-underline mh3 f3 br3 ph3 pv2 custom-link" style="background-color: #e8d3b7; color: black;">Try it Free</Link>
		  {#if token}
			<Link to="/dashboard" class="link white-70 no-underline mh3">Dashboard</Link>
		  {/if}
		</div>
	  </nav>
  
	  <Route path="/" component="{Home}" />
	  <Route path="/login" component="{Login}" />
	  <Route path="/signup" component="{SignUp}" />
	  <Route path="/pricing" component="{Pricing}" />
	  {#if token}
		<Route path="/dashboard" component="{Dashboard}" />
	  {/if}
	</main>
  </Router>
  
  <style>
	html, body {
	  margin: 0;
	  padding: 0;
	  width: 100%;
	  height: 100%;
	}
  
	main {
	  background: linear-gradient(to bottom right, #2c7cc9 50%, #d1e51e);
	  min-height: 100vh;
	  color: white;
	  margin: 0;
	  padding: 0;
	}
  
	.nav {
	  background: #2c7cc9;
	}
  
	.link {
	  color: white;
	  text-decoration: none;
	}
  
	.link:hover {
	  color: rgba(255, 255, 255, 0.7);
	}
  
	.white-70 {
	  color: rgba(255, 255, 255, 0.7);
	}
  
	.features-menu,
	.learn-menu {
	  display: none;
	}
  
	.relative:hover .features-menu,
	.relative:hover .learn-menu {
	  display: block;
	}
  
	.bg-dark-green {
	  background-color: #2c7cc9;
	}
  
	.br3 {
	  border-radius: 0.5rem;
	}
  
	.f1 {
	  font-size: 3rem; /* Adjust as needed */
	}
  
	.f3 {
	  font-size: 1.5rem; /* Adjust as needed */
	}
  
	.custom-link {
	  color: white !important; /* Override global CSS */
	}
  </style>